import AppConstants from '../config/app.constants';

let ShipmentService = function ($http, $q, $translate) {
    let get = (id) => {
        return $http
            .get(AppConstants.api + `/shipment/${id}`)
            .then((res) => {
                return res.data
            })
    };

    let create = (data) => {
        return $http
            .post(AppConstants.api + `/shipment/create`, data)
            .then((res) => {
                return res.data
            })
    };
    let createHold = (data) => {
        return $http
            .post(AppConstants.api + `/shipment/create-hold`, data)
            .then((res) => {
                return res.data
            })
    };

    let verifyShipment = (branchId, trackingId, routeId, date, windowId, fromTankerId, toTankerId) => {
        return $http
            .post(AppConstants.api + `/shipment/verify`, {
                branchId,
                trackingId,
                routeId,
                date,
                windowId,
                fromTankerId,
                toTankerId
            })
            .then((res) => {
                return res.data
            })
    };

    let verifyCheckoutShipment = (branchId, trackingId, routeId, date, windowId, fromTankerId, toTankerId) => {
        return $http
            .post(AppConstants.api + `/shipment/checkout-verify`, {
                branchId,
                trackingId,
                routeId,
                date,
                windowId,
                fromTankerId,
                toTankerId
            })
            .then((res) => {
                return res.data
            })
    };

    let checkinShipment = (branchId, trackingId, routeId, date, windowId, fromTankerId, toTankerId, fromLocationId, isManuallyAddedShipment) => {
        return $http
            .post(AppConstants.api + `/shipment/checkin`, {
                branchId,
                trackingId,
                routeId,
                date,
                windowId,
                fromTankerId,
                toTankerId,
                fromLocationId,
                isManuallyAddedShipment
            })
            .then((res) => {
                return res.data
            })
    };

    let adhocCheckIn = (data) => {
        return $http
            .post(AppConstants.api + `/shipment/adhoc-checkin`, data)
            .then((res) => {
                return res.data
            })
    };

    let checkoutShipment = (branchId, trackingId, routeId, date, windowId, fromTankerId, toTankerId) => {
        return $http
            .post(AppConstants.api + `/shipment/checkout`, {
                branchId,
                trackingId,
                routeId,
                date,
                windowId,
                fromTankerId,
                toTankerId
            })
            .then((res) => {
                return res.data
            })
    }

    let addToBag = (trackingId, deliveryLocationId, bagSealId, branchId) => {
        return $http
            .post(AppConstants.api + `/shipment/add-to-bag`, {
                trackingId,
                deliveryLocationId,
                bagSealId,
                branchId
            })
            .then((res) => {
                return res.data
            })
    };

    let holdShipment = (branchId, trackingId, routeId, date, supervisorId, reason, comments) => {
        return $http
            .post(AppConstants.api + `/shipment/hold`, {
                branchId,
                trackingId,
                routeId,
                date,
                supervisorId,
                reason,
                comments
            })
            .then((res) => {
                return res.data
            })
    }

    let holdMultipleShipments = (branchId, shipments, routeId, date, supervisorId, reason, comments) => {
        return $http
          .post(AppConstants.api + `/shipment/hold-multiple`, {
            branchId,
            shipments,
            routeId, 
            date,
            supervisorId,
            reason,
            comments
          })
          .then((res) => {
            return res.data
          })
      };
    

    let changeShipmentDestination = (trackingId, routeId, date, destinationId) => {
        return $http
            .post(AppConstants.api + `/shipment/change-destination`, {
                trackingId,
                routeId,
                date,
                destinationId
            })
            .then((res) => {
                return res.data
            })
    }

    let changeShipmentAmount = (id, trackingId, routeId, date, shiptypeId, quantity, amount, branchId, oldAmount, supervisorId) => {
        return $http
            .post(AppConstants.api + `/shipment/change-amount`, {
                id, trackingId, routeId, date, shiptypeId, quantity, amount,
                branchId, oldAmount, supervisorId
            })
            .then((res) => {
                return res.data
            })
    }

    let getShipmentRoutes = (refId, date) => {
        return $http
            .get(
                AppConstants.api +
                `/shipment/shipment-routes?date=${date}&` +
                (refId ? `refId=${refId}` : '')
            )
            .then((res) => {
                return res.data
            })
    }

    let throwTanker = (branchId, trackingId, tankerId, deliveryDate, performedByUserId) => {
        return $http
            .post(AppConstants.api + `/shipment/throw-tanker`, {
                branchId,
                trackingId,
                tankerId,
                deliveryDate,
                performedByUserId
            })
            .then((res) => {
                return res.data
            })
    }

    let shipmentReturn = (fromTankerId, trackingId, origRouteId, destRouteId, destRouteDate, supervisorId, comments, branchId) => {
        return $http
            .post(AppConstants.api + `/shipment/shipment-return`, {
                fromTankerId,
                trackingId,
                origRouteId,
                destRouteId,
                destRouteDate,
                supervisorId,
                comments,
                branchId
            })
            .then((res) => {
                return res.data
            })
    }

    let holdRelease = (trackingId, origRouteId, destRouteId, destRouteDate, supervisorId, comments, branchId) => {
        return $http
            .post(AppConstants.api + `/shipment/release-item`, {
                trackingId,
                origRouteId,
                destRouteId,
                destRouteDate,
                supervisorId,
                comments,
                branchId
            })
            .then((res) => {
                return res.data
            })
    }

    let locationNextRoute = (branchId, locationId, afterDate, maxResults) => {
        return $http
            .post(AppConstants.api + `/shipment/location-next-routes`, {
                branchId,
                locationId,
                afterDate,
                maxResults,
            })
            .then((res) => {
                return res.data
            })
    }

    let ServiceItemHistory = (fromLocationId, startDate, endDate, offset, limit, sortColumn, sortASC) => {
        return $http
            .post(AppConstants.api + `/shipment/get-serviceitem-history`, {
                fromLocationId,
                startDate,
                endDate,
                offset,
                limit,
                sortColumn,
                sortASC
            })
            .then((res) => {
                return res.data
            })
    }

    let LocationsItemHistory = (toLocationId, startDate, endDate, offset, limit) => {
        return $http
            .post(AppConstants.api + `/shipment/get-locationitem-history`, {
                toLocationId,
                startDate,
                endDate,
                offset,
                limit
            })
            .then((res) => {
                return res.data
            })
    }

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/shipment`, {
                params: {
                    "search": search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let getShipmentTrakingDetail = (trackingId) => {
        return $http
            .get(AppConstants.api + `/shipment/get-shipment-tracking-detail/${trackingId}`)
            .then((res) => {
                return res.data
            })
    }

    let updateShipmentTankerId = (trackingId, tanker, branchId) => {
        return $http
            .post(AppConstants.api + `/shipment/update-shipment-tankerid`, {
                trackingId,
                tanker,
                branchId
            })
            .then(({
                data
            }) => data)
    }

    let updateDeliveredShipment = (trackingId) => {
        return $http
            .post(AppConstants.api + `/shipment/update-delivered-shipment/${trackingId}`)
            .then((res) => {
                return res.data
            })
    }

    let getDestinationLocations = (locationId, shiptypeId, inclOrigin) => {
        return $http
            .post(AppConstants.api + `/shipment/get-destination-locations`, {
                locationId,
                shiptypeId,
                inclOrigin
            })
            .then((res) => {
                return res.data
            })
    }

    let getCheckoutManifestData = (branchId, routeId, vaultDate) => {
        return $http
            .get(AppConstants.api + `/shipment/get-checkout-manifest`, {
                params: {
                    branchId,
                    routeId,
                    vaultDate
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let getCheckinManifestData = (branchId, routeId, vaultDate) => {
        return $http
            .get(AppConstants.api + `/shipment/get-checkin-manifest`, {
                params: {
                    branchId,
                    routeId,
                    vaultDate
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let isValideTanker = (tankerId, vaultDate) => {
        return $http
            .get(AppConstants.api + `/shipment/get-valide-tanker`, {
                params: {
                    tankerId,
                    vaultDate
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let createShipments = (shipments, supId, holdRoute, branchId, autoGenerateToggle, totalCursor) => {
        return $http
            .post(AppConstants.api + `/shipment/create-shipments`, {
                shipments,
                supId,
                holdRoute,
                branchId,
                autoGenerateToggle,
                totalCursor
            })
            .then((res) => {
                return res.data
            })
    };

    let getShipmentFromLocations = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/shipment/get-from-locations`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let getShipmentToLocations = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/shipment/get-to-locations`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let bulkHoldShipment = (data) => {
        if (!data.length) return [];
        return $http
            .post(AppConstants.api + `/shipment/bulk-shipment-hold`, { data })
            .then((res) => {
                return res.data
            })
    };

    let bulkUpdateDeliveredShipment = (data, branchId) => {
        if (!data.length) return [];
        return $http
            .post(AppConstants.api + `/shipment/bulk-update-delivered-shipment`, { data, branchId })
            .then((res) => {
                return res.data
            })
    }

    let chechTrackingIds = (ids, shipmentId) => {
        return $http
            .get(AppConstants.api + `/shipment/check-shipments`, {
                params: {
                    trackingId: ids,
                    shipmentId: shipmentId
                }
            })
            .then((res) => {
                return res.data
            })
    }
    let getCoinShiptypes = (route, date) => {
        return $http
            .get(AppConstants.api + `/shipment/get-coin-shiptypes`, {
                params: {
                    route,
                    date
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let getItemStatus = (trackingId) => {
        return $http
            .post(AppConstants.api + `/shipment/get-item-status`, {
                trackingId,
                // branchId
            })
            .then((res) => {
                return res.data
            })
    };

    let remainingToThrowShipments = (routeId, vaultDate, branchId, isCoinCheckOut) => {
        return $http
            .post(AppConstants.api + `/shipment/remaining-to-throw`, {
                routeId,
                vaultDate,
                branchId,
                isCoinCheckOut
            })
            .then((res) => {
                return res.data
            })
    }

    let remainingToPackShipments = (routeId, vaultDate, branchId, isCoinCheckOut) => {
        return $http
            .post(AppConstants.api + `/shipment/remaining-to-pack`, {
                routeId,
                vaultDate,
                branchId,
                isCoinCheckOut
            })
            .then((res) => {
                return res.data
            })
    }

    let branchTransfer = (branchId, trackingId, routeId, vaultDate, userId, comments, newRouteId, newVaultDate, fromBranchId) => {
        return $http
            .post(AppConstants.api + `/shipment/branch-transfer`, {
                branchId,
                trackingId,
                routeId,
                vaultDate,
                userId,
                comments,
                newRouteId,
                newVaultDate,
                fromBranchId
            })
            .then((res) => {
                return res.data
            })
    }

    let internalDelivery = (branchId, trackingId, routeId, locationId, vaultDate, userId, comments) => {
        return $http
            .post(AppConstants.api + `/shipment/internal-delivery`, {
                branchId,
                trackingId,
                routeId,
                locationId,
                vaultDate,
                userId,
                comments
            })
            .then((res) => {
                return res.data
            })
    }
    let updateFromLocation = (branchId, trackingId, locationId, userId, comments) => {
        return $http
            .post(AppConstants.api + `/shipment/update-from-location`, {
                branchId,
                trackingId,
                locationId,
                userId,
                comments
            })
            .then((res) => {
                return res.data
            })
    }

    let getOrderType = (type) => {
        switch (type) {
            case type: return $translate.instant('shipment.order_type_' + type);
            default: return '';
        }
    }

    let convertTime = (microSeconds) => {
        var ms = microSeconds / 1000; // convert microSeconds in miliseconds
        // 1- Convert to seconds:
        var seconds = ms / 1000;
        // 2- Extract hours:
        var hours = parseInt(seconds / 3600); // 3,600 seconds in 1 hour
        seconds = seconds % 3600; // seconds remaining after extracting hours
        // 3- Extract minutes:
        var minutes = parseInt(seconds / 60); // 60 seconds in 1 minute
        // 4- Keep only seconds not extracted to minutes:
        seconds = seconds % 60;
        // if (hours < 10) { hours = "0" + hours; }
        if (minutes < 10) { minutes = "0" + minutes; }
        if (seconds < 10) { seconds = "0" + seconds; }
        return (minutes + ':' + seconds);
    }

    let updateShipmentTrackingId = (shipmentId, oldTrackingId, newTrackingId, branchId, comment) => {
        return $http
            .post(AppConstants.api + `/shipment/update-shipment-trackingId`, {
                shipmentId,
                oldTrackingId,
                newTrackingId,
                branchId,
                comment
            })
            .then((res) => {
                return res.data
            })
    }

    let batchRecords = (trackingIds) => {
        return $http
            .post(AppConstants.api + `/shipment/batch-records`, {
                trackingIds
            })
            .then((res) => {
                return res.data
            })
    }

    let deliveryManifestAll = (routeId, vaultDate) => {
        return $http
            .get(AppConstants.api + `/shipment/delivery-manifest-all`, {
                params: {
                    routeId,
                    vaultDate
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let exportServiceHistoryData = (fromLocationId, startDate, endDate, offset, limit) => {
        return $http
            .post(AppConstants.api + `/shipment/export-service-history`, {
                fromLocationId,
                startDate,
                endDate,
                offset,
                limit
            })
            .then((res) => {
                return res.data;
            })
    }

    let getUniqueRecords = (branch) => {
        return $http
            .post(AppConstants.api + `/shipment/unique-records`, {
                branch
            })
            .then((res) => {
                return res.data
            })
    }

    let orderPackingUndo = (branchId, shipmentId, supervisorId, reason, deleteShipment) => {
        return $http
            .post(AppConstants.api + `/shipment/undo-packed-order`, {
                branchId, 
                shipmentId, 
                supervisorId, 
                reason, 
                deleteShipment
            })
            .then((res) => {
                return res.data
            })
    };

    let softDeleteShipment = (shipmentId, branchId, reason, supervisorId) => {
        return $http
            .post(AppConstants.api + `/shipment/soft-delete-shipment`, {
                shipmentId, 
                branchId, 
                reason, 
                supervisorId
            })
            .then((res) => {
                return res.data
            })
    };

    let softDeleteWholeShipment = (orderNo, branchId, supervisorId) => {
        return $http
            .post(AppConstants.api + `/shipment/soft-delete-whole-shipment`, {
                orderNo, 
                branchId, 
                supervisorId
            })
            .then((res) => {
                return res.data
            })
    };

    let deleteOrderDenom = (orderNo, fundingSourceId, denominationId, reason, supervisorId) => {
        return $http
            .post(AppConstants.api + `/shipment/delete-order-denom`, {
                orderNo,
                fundingSourceId,
                denominationId,
                reason,
                supervisorId
            })
            .then((res) => {
                return res.data
            })
    };

    let undoSoftDeleteShipment = (shipmentId, branchId, trackingId) => {
        return $http
            .post(AppConstants.api + `/shipment/undo-soft-delete-shipment`, {
                shipmentId,
                branchId,
                trackingId
            })
            .then((res) => {
                return res.data
            })
    };

    let getShipmentsOnRoute = (routeId, vaultDate, coinCheckOut) => {
        return $http
            .post(AppConstants.api + `/shipment/get-shipments-on-route`, {
                routeId, 
                vaultDate, 
                coinCheckOut
            })
            .then((res) => {
                return res.data
            })
    };

    let changeDestination = (trackingId, branchId, routeId, destinationId, comment) => {
        return $http
            .post(AppConstants.api + `/shipment/change-shipment-destination`, {
                trackingId, 
                branchId, 
                routeId,
                destinationId,
                comment
            })
            .then((res) => {
                return res.data
            })
    };

    let getPendingCancelShipments = (branchId, offset, limit, routeId, vaultDate) => {
        return $http
            .get(AppConstants.api + `/shipment/get-pending-cancel-shipments`, {
                params: {
                    branchId, 
                    offset, 
                    limit,
                    routeId,
                    vaultDate
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let getCancelledShipments = (branchId, offset, limit) => {
        return $http
            .get(AppConstants.api + `/shipment/get-cancelled-shipments`, {
                params: {
                    branchId, 
                    offset, 
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let getDeliveryServiceHistory = (locationId, branchId, startDate, endDate, offset, limit, searchText, sortColumn, sortASC) => {
        return $http
            .get(AppConstants.api + `/shipment/get-delivery-service-history`, {
                params: {
                    locationId,
                    branchId,
                    startDate,
                    endDate,
                    offset,
                    limit,
                    searchText,
                    sortColumn,
                    sortASC
                }
            })
            .then((res) => {
                return res.data
            })
    }


    let getPickupServiceHistory = (locationId, branchId, startDate, endDate, offset, limit, searchText, sortColumn, sortASC, timezone) => {
        return $http
            .get(AppConstants.api + `/shipment/get-pickup-service-history`, {
                params: {
                    locationId,
                    branchId,
                    startDate,
                    endDate,
                    offset,
                    limit,
                    searchText,
                    sortColumn,
                    sortASC,
                    timezone
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let printPickupServiceHistory = (locationId, startDate, endDate, timezone, searchText, sortColumn, sortASC) => {
        return $http
            .get(AppConstants.api + `/shipment/print-pickup-service-history`, {
                params: {
                    locationId,
                    startDate,
                    endDate,
                    timezone,
                    searchText,
                    sortColumn,
                    sortASC

                }
            })
            .then((res) => {
                return res.data
            })
    }

    let exportPickupServiceHistory = (locationId, startDate, endDate, timezone, searchText, selectedDepositAmountValue, sortColumn, sortASC) => {
        return $http
            .post(AppConstants.api + `/shipment/export-pickup-service-history`, {
                locationId,
                startDate,
                endDate,
                timezone,
                searchText,
                selectedDepositAmountValue,
                sortColumn,
                sortASC
            })
            .then((res) => {
                return res.data
            })
    }

    let printDeliveryServiceHistory = (locationId, startDate, endDate, timezone, searchText, sortColumn, sortASC) => {
        return $http
            .get(AppConstants.api + `/shipment/print-delivery-service-history`, {
                params: {
                    locationId,
                    startDate,
                    endDate,
                    timezone,
                    searchText,
                    sortColumn,
                    sortASC
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let exportDeliveryServiceHistory = (locationId, startDate, endDate, timezone, searchText, sortColumn, sortASC) => {
        return $http
            .post(AppConstants.api + `/shipment/export-delivery-service-history`, {
                locationId,
                startDate,
                endDate,
                timezone,
                searchText,
                sortColumn,
                sortASC
            })
            .then((res) => {
                return res.data
            })
    }

    let holdShipmentNotDelivered = (branchId, trackingId, routeId, date, supervisorId, reason, deliveryResolution, note, notDeliveredResolution, holdType , updatedTrackingId, originalTrackingId, amount, qty, destinationId, fromLocationId, shiptypeId) => {
        return $http
            .post(AppConstants.api + `/shipment/hold-not-delivered`, {
                branchId,
                trackingId,
                routeId,
                date,
                supervisorId,
                reason,
                deliveryResolution,
                note,
                notDeliveredResolution,
                holdType,
                updatedTrackingId,
                originalTrackingId,
                amount,
                qty,
                destinationId,
                fromLocationId,
                shiptypeId
            })
            .then((res) => {
                return res.data
            })
    }

    let shipmentReRoute = ( branchId, trackingId, routeId, destRouteId, destRouteDate, supervisorId, reason, deliveryResolution, note,updatedTrackingId,originalTrackingId, amount, qty, destinationId, fromLocationId, shiptypeId) => {
        return $http
        .post(AppConstants.api + `/shipment/shipment-re-route`, {
            branchId, trackingId, routeId, destRouteId, destRouteDate, supervisorId, reason, deliveryResolution, note , updatedTrackingId,originalTrackingId, amount, qty, destinationId, fromLocationId, shiptypeId
        })
        .then((res) => {
            return res.data
        })
    }

    let shipmentPickupsReRoute = (branchId, trackingId, routeId, destRouteId, destRouteDate, supervisorId, note) => {
        return $http
            .post(AppConstants.api + `/shipment/pickups-re-route`, {
                branchId, trackingId, routeId, destRouteId, destRouteDate, supervisorId, note
            })
            .then((res) => {
                return res.data
            })
    }

    let hasCustomerShipment = (trackingId, customerId, branchId)  => {
        return $http
        .get(AppConstants.api + `/shipment/is-customer-shipment`, {
            params: {
                trackingId, customerId, branchId
            }
        })
        .then((res) => {
            return res.data
        })
    }

    let uploadBatchFiles = (files) => {
        return $http
            .post(AppConstants.api + `/shipment/upload-batch-files`, { files })
            .then((res) => {
                return res.data
            })
    }

    let getBatchTemplateFile = () => {
        return $http
            .get(AppConstants.api + `/shipment/get-batch-template-file`)
            .then((res) => {
                return res.data
            })
    };

    let makeDeliverable = (trackingId, routeId, vaultDate, userId, branchId) => {
        return $http
            .post(AppConstants.api + `/shipment/make-deliverable`, { trackingId, routeId, vaultDate, userId, branchId })
            .then((res) => {
                return res.data
            })
    }

    let printStopReceipt = (trackingId, selectedDepositAmountValue) => {
        return $http
            .post(AppConstants.api + `/shipment/print-stop-receipt`, { trackingId, selectedDepositAmountValue })
            .then((res) => {
                return res.data
            })
    }

    let changeShiptype = (trackingId, branchId, shiptype) => {
        return $http
            .post(AppConstants.api + `/shipment/change-shiptype`, {
                trackingId,
                branchId,
                shiptype
            })
            .then((res) => {
                return res.data
            })
    };

    let verifyTruckLiability = (routeId, vaultDate, truckLiability, shipmentAmount = 0) => {
        return $http.post(AppConstants.api + `/shipment/verify-truck-liability`, {
            routeId, vaultDate, truckLiability
        }).then((res) => {
            const isWithinLiability = (res.data.totalAmount + shipmentAmount) < truckLiability;
            return { isWithinLiability };
        })
    }

    let deliveryManifestCombined = (routeId, vaultDate) => {
        return $http
            .get(AppConstants.api + `/shipment/delivery-manifest-combined`, {
                params: {
                    routeId,
                    vaultDate
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let bulkUpdateNoPickupStop = (data, branchId) => {
        return $http.post(AppConstants.api + `/shipment/bulk-update-no-pickup-stop`, { data, branchId })
            .then((res) => {
                return res.data
            })
    };

    let completedShipments = (branchId, vaultDate, offset, limit, searchText, sortASC, sortColumn) => {
        return $http
            .get(AppConstants.api + `/shipment/completed-shipments`, {
                params: { branchId, vaultDate, offset, limit, searchText, sortASC, sortColumn}
            })
            .then((res) => {
                return res.data
            })
    };

    let printCompletedShipments = (batchId, locationId) => {
        return $http
            .get(AppConstants.api + `/shipment/print-completed-shipments`, {
                params: { batchId, locationId }
            })
            .then((res) => {
                return res.data
            })
    }

    let createCheckinManifest = (fromLocationId, vaultDate, routeId, totalBagCount, manifestID, userIdCompleted) => {
        return $http.post(AppConstants.api + `/shipment/checkin-manifests`, {
            fromLocationId, vaultDate, routeId, totalBagCount, manifestID, userIdCompleted
        }).then((res) => {
            return res.data;
        })
    };
   
    let updateShipmentCountStatus = (trackingId , toLocationId, fundingSourceId) => {
        return $http.post(AppConstants.api + `/shipment/update-count-status`, {
            trackingId,
            toLocationId,
            fundingSourceId
        }).then((res) => {
            return res.data;
        })
    };

    let getShipmentLocationDetails = (locationId) => {
        return $http
            .get(AppConstants.api + `/shipment/get-shipment-location/${locationId}`)
            .then((res) => {
                return res.data
            })
    }

    let getDeliveryServiceTransaction = (locationId, branchId, vaultDate, trackingId) => {
        return $http
            .get(AppConstants.api + `/shipment/get-delivery-service-transaction`, {
                params: {
                    locationId,
                    branchId,
                    vaultDate,
                    trackingId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let putShipmentOnHold = (branchId, trackingId, routeId, date, supervisorId, reason, comments, updatedTrackingId, originalTrackingId, amount, qty, destinationId, fromLocationId, shiptypeId) => {
        return $http
            .post(AppConstants.api + `/shipment/put-shipment-on-hold`, {
                branchId, trackingId, routeId, date, supervisorId, reason, comments, updatedTrackingId, originalTrackingId, amount, qty, destinationId, fromLocationId, shiptypeId
            })
            .then((res) => {
                return res.data
            })
    }

    let getChangeDestinationLocations = (trackingId, branchId, searchKey, offset, limit) => {
      return $http
        .get(AppConstants.api + `/shipment/get-change-destination-locations`, {
          params: {
            trackingId,
            branchId,
            searchKey,
            offset,
            limit,
          },
        })
        .then((res) => {
          return res.data
        })
    }

    const pendingShipmentTransferDetails = (routeId, routeDate, branchId) => {
        return $http
            .get(AppConstants.api + `/shipment/pending-shipment-transfer-details`, {
                params: {
                    routeId,
                    routeDate,
                    branchId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    const resendShipmentTransfer = (trackingIds, transferOutUserId, transferInUserId, transferOutRouteId, transferInRouteId, 
                                    transferOutBranchId, transferInBranchId, transferOutTruckId, transferInTruckId, comment, 
                                    transferInVaultDate, transferOutVaultDate, shipmentTransferIds) => {
        return $http
            .post(AppConstants.api + `/shipment/resend-shipment-transfer`, {
                trackingIds,
                transferOutUserId,
                transferInUserId,
                transferOutRouteId,
                transferInRouteId,
                transferOutBranchId,
                transferInBranchId,
                transferOutTruckId,
                transferInTruckId,
                comment,
                transferInVaultDate,
                transferOutVaultDate,
                shipmentTransferIds
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        get,
        create,
        createHold,
        verifyShipment,
        checkinShipment,
        checkoutShipment,
        addToBag,
        holdShipment,
        verifyTruckLiability,
        changeShipmentDestination,
        changeShipmentAmount,
        getShipmentRoutes,
        verifyCheckoutShipment,
        throwTanker,
        shipmentReturn,
        holdRelease,
        locationNextRoute,
        LocationsItemHistory,
        ServiceItemHistory,
        all,
        getShipmentTrakingDetail,
        updateShipmentTankerId,
        updateDeliveredShipment,
        getDestinationLocations,
        getCheckoutManifestData,
        getCheckinManifestData,
        isValideTanker,
        createShipments,
        getShipmentFromLocations,
        getShipmentToLocations,
        bulkHoldShipment,
        bulkUpdateDeliveredShipment,
        chechTrackingIds,
        getCoinShiptypes,
        getItemStatus,
        remainingToThrowShipments,
        remainingToPackShipments,
        branchTransfer,
        internalDelivery,
        getOrderType,
        convertTime,
        updateShipmentTrackingId,
        batchRecords,
        deliveryManifestAll,
        exportServiceHistoryData,
        getUniqueRecords,
        orderPackingUndo,
        softDeleteShipment,
        softDeleteWholeShipment,
        deleteOrderDenom,
        undoSoftDeleteShipment,
        getShipmentsOnRoute,
        changeDestination,
        getPendingCancelShipments,
        getCancelledShipments,
        getDeliveryServiceHistory,
        getPickupServiceHistory,
        printPickupServiceHistory,
        exportPickupServiceHistory,
        printDeliveryServiceHistory,
        exportDeliveryServiceHistory,
        holdShipmentNotDelivered,
        shipmentReRoute,
        hasCustomerShipment,
        uploadBatchFiles,
        getBatchTemplateFile,
        makeDeliverable,
        printStopReceipt,
        changeShiptype,
        deliveryManifestCombined,
        bulkUpdateNoPickupStop,
        completedShipments,
        printCompletedShipments,
        createCheckinManifest,
        updateShipmentCountStatus,
        getShipmentLocationDetails,
        getDeliveryServiceTransaction,
        holdMultipleShipments,
        putShipmentOnHold,
        getChangeDestinationLocations,
        pendingShipmentTransferDetails,
        resendShipmentTransfer,
        shipmentPickupsReRoute,
        adhocCheckIn,
        updateFromLocation
    };

};

ShipmentService.$inject = ['$http', '$q', '$translate']

export default ShipmentService;



// WEBPACK FOOTER //
// ./client/app/services/shipment.service.js